import * as React from 'react';
import styled from 'styled-components';

export const PandoraIsologo: React.FC<React.SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <path d="M12 0C9.7 0 7.6 0.8 6 2.1V0.6H2.5V24h1.8C5.2 24 6 23.2 6 22.3v-5.5c1.6 1.3 3.7 2.1 6 2.1 5.3 0 9.5-4.2 9.5-9.5S17.3 0 12 0zM11.8 15.3c-3.3 0-5.9-2.6-5.9-5.9s2.7-5.9 5.9-5.9c3.3 0 5.9 2.6 5.9 5.9S15.1 15.3 11.8 15.3z" />
    </svg>
  );
};

export default styled(PandoraIsologo)`
  & > path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
